import type {
  ApiObject,
  ApiObjectWithReferences,
  SVG,
} from "@/models/api";

export type SortedObjectsWrapper = {
  data: ApiObjectWithReferences;
  children: ApiObjectWithReferences[];
  parentID: number | null;
};

export type CsvRow = {
  title: string;
  barcode: string;
  url: string;
};

export type ObjectsMappedByID = Array<SortedObjectsWrapper> & {
  [index: number]: SortedObjectsWrapper;
};

export type IconMapping = {
  [key: string]: SVG;
};

export type IconWithName = {
  name: string;
  meta: SVG;
};

export type ObjectWithId = {
  id: number;
};

export function isObjectWithId(obj: any): obj is ObjectWithId {
  // noinspection PointlessBooleanExpressionJS
  return (
    true
    && typeof obj === "object"
    && obj !== null
    && "id" in obj
    && typeof obj.id === "number"
  );
}

export function isApiObject(apiObject: any): apiObject is ApiObject {
  // noinspection PointlessBooleanExpressionJS
  return (
    // eslint-disable-next-line
    true
    // eslint-disable-next-line
    && typeof apiObject === "object"
    && "name" in apiObject
    // eslint-disable-next-line
    && "type" in apiObject
  );
}
